import { component } from 'picoapp'
import SearchModal from '@/utils/search-modal.js'

class Header {

  constructor(node, ctx) {
    // bindings
    this.gotSendy = this.gotSendy.bind(this)
    this.onPJAXSuccess = this.onPJAXSuccess.bind(this)
    this.openMenu = this.openMenu.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
    this.onMenuBtnClick = this.onMenuBtnClick.bind(this)
    this.onCartUpdated = this.onCartUpdated.bind(this)
    this.onCartClick = this.onCartClick.bind(this)
    this.onBgCartClick = this.onBgCartClick.bind(this)
    this.setCartOpenState = this.setCartOpenState.bind(this)
    this.onResize = this.onResize.bind(this)
    this.onSearchBtnClick = this.onSearchBtnClick.bind(this)

    this.dropdownLinkMouseEnter = this.dropdownLinkMouseEnter.bind(this)
    this.dropdownMouseLeave = this.dropdownMouseLeave.bind(this)
    this.dropdownMenuLinkMouseEnter = this.dropdownMenuLinkMouseEnter.bind(this)
    this.pageTransitionHideDropdownMenu = this.pageTransitionHideDropdownMenu.bind(this)

    this.clickDropdownLink = this.clickDropdownLink.bind(this)

    // Header selectors
    this._node = node;
    this._menu_btn = document.getElementById('menu-btn')
    this._cart_bg = document.getElementById('cart-bg')
    this._cart_btns = this._node.getElementsByClassName('cart-btn')

    // Mobile menu selectors
    this._menu = document.getElementById('menu')
    this._menu_scroller = document.getElementById('menu-scroller')
    this._menu_accordion = Array.from(this._menu.getElementsByClassName('content-accordion'))

    // All nav links
    this._nav_links = document.querySelectorAll('.nav-link')

    // Search
    this._search_btn = document.querySelectorAll('.search-btn')
    this._search_modal = false

    // Dropdown menu
    this._nav_item = this._node.querySelectorAll('.nav-item')
    this._dropdown_link = this._node.querySelectorAll('.dropdown-link')
    this._dropdown_menu = document.getElementById('dropdown-menu')
    this._dropdown_content = document.querySelectorAll('.dropdown-content')
    this._dropdown_menu_link = document.querySelectorAll('.dropdown-menu-link')
    this._dropdown_images = Array.from(document.querySelectorAll('.image-holder'))
    this._active_dropdown = false

    // CTX
    this._ctx = ctx

    // Event listeners
    document.addEventListener('pjax:send', this.gotSendy)
    document.addEventListener('pjax:success', this.onPJAXSuccess)
    this._menu_btn.addEventListener('click', this.onMenuBtnClick, false)
    this._cart_bg.addEventListener('click', this.onBgCartClick, false)
    Array.from(this._cart_btns).forEach((btn) => btn.addEventListener('click', this.onCartClick, false))
    Array.from(this._search_btn).forEach((btn) => btn.addEventListener('click', this.onSearchBtnClick, false))
    window.addEventListener('resize', this.onResize)

    this._dropdown_menu.addEventListener('mouseleave', this.dropdownMouseLeave, false)
    Array.from(this._nav_item).forEach((el) => el.addEventListener('mouseenter', this.dropdownLinkMouseEnter, false))
    Array.from(this._dropdown_menu_link).forEach((el) => el.addEventListener('mouseenter', this.dropdownMenuLinkMouseEnter, false))
    this._dropdown_link.forEach((el) => el.addEventListener('click', this.clickDropdownLink, false))

    this._ctx.on('cart:updated', this.onCartUpdated)

    // Init
    if (this._ctx.getState().pjax === false) {
      this.init()
    }

    this.unmount.bind(this)
  }

  //
  // Init.
  //
  init() {
    this.setActiveStuff()
  }

  //
  // You know you want to send it.
  //
  gotSendy() {
    this.closeMenu()
    this.pageTransitionHideDropdownMenu()
    this.setCartOpenState(false)
  }

  //
  // Handle PJAX success.
  //
  onPJAXSuccess() {
    this.setActiveStuff()
  }

  //
  // Set active stuff.
  //
  setActiveStuff() {
    let path = window.location.pathname

    if (path === '/') {
      this._node.classList.add('a-bar')
    } else {
      this._node.classList.remove('a-bar')
    }

    if (path.split('/')[1] === 'account') {
      path = '/account'
    }

    if (path === '/products') {
      path = '/collections/shop'
    }

    Array.from(this._nav_links).forEach((link) => {
      let href = link.getAttribute('href')
      link.classList.remove('active')

      if (path === href) {
        link.classList.add('active')
      }
    })
  }

  //
  // Handle menu btn click.
  //
  onMenuBtnClick() {
    if (document.body.classList.contains('open-menu') === false) {
      this.openMenu()
    } else {
      this.closeMenu()
    }
  }

  onBgCartClick() {
    if (document.body.classList.contains('cart-open') === true) {
      this.setCartOpenState(false)
    }
  }

  //
  // Open menu.
  //
  openMenu(menu) {
    if (this._ctx.getState().cartOpen === true) {
      this.setCartOpenState(false)
    }

    this._menu_accordion.forEach((el) => {
      if (el.classList.contains('expanded')) {
        let wrapper = el.querySelector('.accordion-wrapper')
        el.classList.remove('expanded')
        wrapper.classList.add('no-trans')
        wrapper.style.height = '0px'
        wrapper.offsetHeight
        wrapper.classList.remove('no-trans')
      }
    })

    this._node.offsetHeight
    this._menu_scroller.scrollTop = 0
    document.body.classList.add('open-menu')
  }

  //
  // Close menu.
  //
  closeMenu() {
    document.body.classList.remove('open-menu')
  }

  //
  // Handle cart updated.
  //
  onCartUpdated(state) {
    Array.from(this._cart_btns).forEach((count) => {
      if (count.classList.contains('cart-icon')) {
        count.innerHTML = `<strong>${state.cart.item_count}</strong>`
      } else {
        count.innerHTML = `<strong>Cart (${state.cart.item_count})</strong>`
      }
    })
  }

  //
  // Cart click
  //
  onCartClick() {
    this.hideDropdownMenu(true)

    if (this._ctx.getState().cartOpen === false) {
      this.setCartOpenState(true)
    } else {
      this.setCartOpenState(false)
    }
  }

  //
  // Search btn click
  //
  onSearchBtnClick() {
    this.hideDropdownMenu(true)

    this._search_modal = new SearchModal()
    this._search_modal.activateSearchModal()
  }

  //
  // Set global cart open state.
  //
  setCartOpenState(open) {
    if (this._node.classList.contains('open-menu') === true) {
      this.closeMenu()
    }

    this._ctx.emit('cart:toggle', (state) => {
      return {
        cartOpen: open
      }
    })
  }

  // Close menu on resize
  onResize() {
    if (window.innerWidth >= 768) {
      this.closeMenu()
    }
  }

  //
  // Click dropdown link
  //
  clickDropdownLink(e) {
    let id = e.currentTarget.getAttribute('data-id')

    if (this._node.classList.contains('show-dropdown')) {
      this.hideDropdownMenu(true)
    } else {
      setTimeout(() => {
        this.showDropdownMenu(id)
        this.showDropdownImage(id)
      }, 0)
    }
  }

  //
  // Mouseenter dropdown link
  //
  dropdownLinkMouseEnter(e) {
    let el = e.currentTarget,
        id = e.currentTarget.getAttribute('data-id')

    if (el.classList.contains('dropdown-link')) {
      setTimeout(() => {
        this.showDropdownMenu(id)
        this.showDropdownImage(id)
      }, 0)
    } else {
      this.hideDropdownMenu()
    }
  }

  dropdownMouseLeave() {
    setTimeout(() => {
      if (this._active_dropdown === true) {
        this.hideDropdownMenu()
      }
    }, 333)
  }

  dropdownMenuLinkMouseEnter(e) {
    let id = e.currentTarget.getAttribute('data-id')
    this.showDropdownImage(id)
  }

  showDropdownImage(id) {
    this._dropdown_images.forEach((el) => {
      el.classList.remove('--selected')

      if (el.getAttribute('data-id') === id) {
        el.classList.add('--selected')
      }
    })
  }

  showDropdownMenu(id) {
    this._dropdown_content.forEach((el, i) => {
      el.style.display = "none"

      if (id === el.getAttribute('data-id')) {
        el.style.display = "block"
      }
    })

    if (this._active_dropdown === false) {
      this._active_dropdown = true
      this._node.classList.remove('show-dropdown', 'hide-dropdown')
      this._dropdown_menu.style.display = "block"
      this._dropdown_menu.offsetHeight
      this._node.classList.add('show-dropdown')
      document.body.classList.add('lock')
    }
  }

  hideDropdownMenu(force) {
    let can_hide = true

    // Check if we have roll off and rolloed over dropdown link during hide transition
    if (!force) {
      this._dropdown_link.forEach((el) => {
        if (el.matches(':hover')) {
          can_hide = false
        }
      })
    }

    if (this._active_dropdown === true && can_hide === true) {
      this._active_dropdown = false
      this._node.classList.remove('show-dropdown', 'hide-dropdown')
      this._node.classList.add('hide-dropdown')
      document.body.classList.remove('lock')

      setTimeout(() => {
        if (this._active_dropdown === false) {
          this._node.classList.remove('show-dropdown', 'hide-dropdown')
          this._dropdown_menu.style.display = "none"
          document.body.classList.remove('lock')
        }
      }, 333)
    }
  }

  pageTransitionHideDropdownMenu() {
    this._active_dropdown = false
    this._node.classList.remove('show-dropdown', 'hide-dropdown')
    this._node.classList.add('hide-dropdown')
    document.body.classList.remove('lock')

    setTimeout(() => {
      this._active_dropdown = false
      this._node.classList.remove('show-dropdown', 'hide-dropdown')
      this._dropdown_menu.style.display = "none"
      document.body.classList.remove('lock')
    }, 333)
  }

  //
  // Unmount.
  //
  unmount() {
    document.removeEventListener('pjax:send', this.gotSendy)
    document.removeEventListener('pjax:success', this.onPJAXSuccess)
    this._menu_btn.removeEventListener('click', this.onMenuBtnClick, false)
    this._cart_bg.removeEventListener('click', this.onBgCartClick, false)
    Array.from(this._cart_btns).forEach((btn) => btn.removeEventListener('click', this.onCartClick, false))
    Array.from(this._search_btn).forEach((btn) => btn.removeEventListener('click', this.onSearchBtnClick, false))
    window.removeEventListener('resize', this.onResize)

    this._dropdown_menu.removeEventListener('mouseleave', this.dropdownMouseLeave, false)
    Array.from(this._nav_item).forEach((el) => el.removeEventListener('mouseenter', this.dropdownLinkMouseEnter, false))
    Array.from(this._dropdown_menu_link).forEach((el) => el.removeEventListener('mouseenter', this.dropdownMenuLinkMouseEnter, false))
    this._dropdown_link.forEach((el) => el.removeEventListener('click', this.clickDropdownLink, false))
  }
}

export default component((node, ctx) => new Header(node, ctx))
